import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import TableEssayCompetencias from "./Table/TableEssayCompetencias";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  }
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2)
  }
}))(MuiDialogContent);

export default function ModalCompetenciasEnem({ showModalObj, setShowModalObj }) {
  const open = showModalObj.isOpen;

  const handleClose = () => {
    setShowModalObj(false);
  };

  return (
    <div>
       <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          {showModalObj.competenciaDataCategory.titulo}
        </DialogTitle>
        <div style={{
          padding: '0px 16px 16px 16px',
          fontSize: '16px',
          textAlign: 'justify',
        }} >
          {showModalObj.competenciaDataCategory.subTitulo}
        </div>
        <DialogContent dividers>
          <TableEssayCompetencias descricaoCompetencia={showModalObj.competenciaDataCategory} />
        </DialogContent>
      </Dialog>
    </div>
  );
}
